module.exports = __webpack_public_path__ + "img/MEDIA014.8d278dfa.jpg";